import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { showFilterDialog } from "../../dialog/Filter";
import { showLoadingPage, showLoadingDialog } from "../../native/Loading";
import {
    showErrorPage,
    showErrorDialog,
    ERR_REFRESH,
    ERR_REGULAR_FUNC,
} from "../../native/Error";
import { showConfirmation } from "../../native/Confirmation";
import { onRequest } from "../../utilities/Request";

import ic_left from "../../images/left_arrow_b.png";
// import ic_search from "../../images/search_a.png";
// import ic_discount from "../../images/Icon_persen.png";
// import ic_arrow_down from "../../images/arrow-down.png";
// import ic_arrow_up from "../../images/cancel_b.png";
// import ic_discount from "../../images/tickets.png";
// import ic_cart from "../../images/grocery-cart.png"; // Add this import for the cart icon
import {
    COOKIES_CUSTOMER_ID,
    COOKIES_REG_ID_UL,
    COOKIES_STATUS_UL,
    getCookies,
} from "../../utilities/Cookies";
import { extractValueFromCombined } from "../../utilities/Function";
import { showAlertDialog } from "../../dialog/Alert";
import {
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Divider,
    IconButton,
    Paper,
    TextField,
    CircularProgress,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import AlertOutlinedIcon from '@mui/icons-material/AlertOutlined';
import { getStringStorage, STORAGE_ORDER_BERSAMA } from "../../utilities/Storage";
import { FEATURE_VICTORY } from "../../constant";
import { suspectionLog } from "../../utilities/FakeGpsDetector";

const DEFAULT_MAX_QUANTITY = 9999;
const ENV_MAX_QUANTITY = Number(process.env.REACT_APP_MAX_QUANTITY);
const MAX_QUANTITY =
    Number.isInteger(ENV_MAX_QUANTITY) && ENV_MAX_QUANTITY > 0
        ? ENV_MAX_QUANTITY
        : DEFAULT_MAX_QUANTITY;

class SummaryCartReguler extends Component {
    constructor(props) {
        super(props);

        this.params = new URLSearchParams(this.props.location.search);
        this.state = {
            list_document: [],
            pagination: null,
            confirmation_dialog: {
                show: false,
                title: "",
                message: "",
                data: null,
                listener: null,
            },
            ekstrak: extractValueFromCombined(getCookies(COOKIES_STATUS_UL)),
            region_id_ul: getCookies(COOKIES_REG_ID_UL),
            cart: [],
            metadata_cart: null,
            showFloatingButton: true,
            titleHeader: null,
            selectedPaymentMethod: 1,
            paymentOptions: [
                {
                    value: 1,
                    label: "Bayar Langsung (COD)",
                }
            ],
            totalPrice: 0,
            partialOrderAcceptance: false, // Changed to boolean for checkbox
            selectedShippingMethod: true, // Default to "Kirim Ke Toko"
            shippingOptions: [
                {
                    key: true,
                    tag: "1",
                    text: "Kirim Ke Toko"
                },
                {
                    key: false,
                    tag: "2",
                    text: "Ambil Di Grosir"
                }
            ],
            dataParam: JSON.parse(getStringStorage(STORAGE_ORDER_BERSAMA)),
            custNoHp: null,
            reff_id: null,
            orderSuccessModal: {
                open: false,
                orderData: null
            },
            note: "",
            currentPosition: null,
            delivery_price: null,
            delivery_platform: null,
            isOrderButtonDisabled: false,
            isOrderingInProgress: false, // Track if order API is being processed
            stockData: null,
            outOfStockProductIds: [],
        };
        this.scrollTimeout = null;
        this.initialCart = [];
    }

    componentDidMount() {
        this.getLocation(true, true);
        this.getDeliveryPricePlatform();
    }

    getDeliveryPricePlatform() {
        try {
            let body = {
                wholesalerId: this.state.dataParam.wholesaler_id,
            };
            let endpoint = "/get/delivery_platform_price";
            //   if (next_page) {
            //     body.pagination = this.state.pagination;
            //   }
            onRequest(
                endpoint,
                body,
                (res_success) => {
                    this.setState({
                        loading_page: false,
                        delivery_price: res_success?.result?.delivery_price,
                        delivery_platform: res_success?.result?.delivery_platform,
                        // pagination: res_success.result.pagination,
                    });
                },
                (res_fail) => {
                    this.setState({
                        loading_page: false,
                        error_page: {
                            message: res_fail.message,
                            result: { action: ERR_REFRESH, message: "Refresh" },
                        },
                    });
                }
            );
        } catch (error) {
            console.log("error", error);
        }
    }

    getLocation(high_acc, is_loading) {
        this.setState({ loading_page: is_loading }, () => {
            navigator.geolocation.getCurrentPosition((pos) => {
                this.setState({
                    loading_page: is_loading,
                    currentPosition: pos.coords
                }, async () => {
                    if (is_loading) {
                        this.requestDocument("loading_page", "error_page", false);
                    }
                });
            }, (err) => {
                this.setState({
                    loading_page: false,
                    error_page: { message: err.message, result: { action: ERR_REGULAR_FUNC, message: 'Coba Lagi!', _func: this.getLocation.bind(this, false, false) } }
                });
            }, { enableHighAccuracy: high_acc, timeout: 15000 });
        });
    }

    handleAdd = (internalReference) => {
        // Guard: jangan tambah qty kalau produk out-of-stock (stock < 1)
        if (
            Array.isArray(this.state.outOfStockProductIds) &&
            this.state.outOfStockProductIds.includes(internalReference)
        ) {
            return;
        }
        this.setState((prevState) => {
            const product = this.state.list_document.find(
                (p) => p.internal_reference === internalReference
            );
            const existingProduct = prevState.cart.find(
                (p) => p.internal_reference === internalReference
            );

            // Max quantity = stock (UOM-aware dari getCartItemStockNumber)
            // || MAX_QUANTITY (9999 default). Kalau stock < 1 → skip.
            const max = existingProduct
                ? this.getMaxQuantityForCartItem(existingProduct)
                : MAX_QUANTITY;
            if (max < 1) return null;

            let newCart;
            if (existingProduct) {
                newCart = prevState.cart.map((p) =>
                    p.internal_reference === internalReference
                        ? { ...p, quantity: Math.min(p.quantity + 1, max) }
                        : p
                );
            } else {
                newCart = [
                    ...prevState.cart,
                    {
                        product_name: product.product_name.en_US,
                        internal_reference: internalReference,
                        price_unit: product.sales_price,
                        quantity: Math.min(1, max),
                        image_url: product.image_url,
                    },
                ];
            }

            const totalPrice = this.calculateTempCartTotalPrice(newCart);

            return { cart: newCart, totalPrice };
        }, this.createPayload); // Create payload after adding item
    };

    handleRemove = (internalReference) => {
        this.setState((prevState) => {
            const existingProduct = prevState.cart.find(
                (p) => p.internal_reference === internalReference
            );

            let newCart;
            if (existingProduct && existingProduct.quantity > 1) {
                newCart = prevState.cart.map((p) =>
                    p.internal_reference === internalReference
                        ? { ...p, quantity: p.quantity - 1 }
                        : p
                );
            } else {
                newCart = prevState.cart.filter(
                    (p) => p.internal_reference !== internalReference
                );
            }

            const totalPrice = this.calculateTempCartTotalPrice(newCart);

            return { cart: newCart, totalPrice };
        }, this.createPayload); // Create payload after removing item
    };

    handleRemoveItem = (internalReference) => {
        const newCart = this.state.cart.filter(
            (item) => item.internal_reference !== internalReference
        );
        if (newCart.length === this.state.cart.length) return;

        const newTotal = this.calculateTempCartTotalPrice(newCart);
        this.setState({ cart: newCart, totalPrice: newTotal }, () => {
            // Sync perubahan ke backend via /post/add_to_cart
            this.addToCart(false);
        });
    };

    createPayload = () => {
        const { cart, totalPrice, reff_id } = this.state;

        const payload = {
            cust_no_sales: getCookies(COOKIES_CUSTOMER_ID),
            cust_no_odoo: this.params.get("cust_odoo"),
            branch_id: 2, // Assuming branch ID is 2, adjust as necessary
            reff_id,
            notes: null,
            payment_term_name: this.state.selectedPaymentMethod,
            items: cart.map((product) => ({
                pcode: product.internal_reference,
                qty: product.quantity,
                price: product.price_unit,
                uom: product.uom, // Assuming UOM is "DUS", adjust as necessary
            })),
        };

        // console.log("Payload for create order:", payload);
        // Optionally, you can send this payload to the server here
    };

    createOrder = async () => {
        const { cart, totalPrice, reff_id, selectedPaymentMethod, partialOrderAcceptance, selectedShippingMethod, outOfStockProductIds } = this.state;
        const handlingDeliveryFee = this.getHandlingDeliveryFee();
        const totalPayment = this.getTotalPayment();

        // Check suspection
        await suspectionLog(
            this.state.currentPosition.accuracy,
            this.state.currentPosition.longitude,
            this.state.currentPosition.latitude,
            FEATURE_VICTORY.ORDER_SFA
        );

        // Exclude produk dengan stock < 1 (out-of-stock) dari payload /post/order
        const outOfStockSet = new Set(outOfStockProductIds || []);
        const productsToOrder = cart.filter(
            (product) => !outOfStockSet.has(product.internal_reference)
        );

        // Find the shipping method object
        const deliveryAction = this.state.shippingOptions.find(option => option.key === selectedShippingMethod);

        const payload = {
            wholesaler_id: this.state.dataParam.wholesaler_id,
            products: productsToOrder.map((product) => ({
                name: product.product_name,
                product_id: product.internal_reference,
                quantity: product.isUseBigUom ? String(Number(product.quantity * product.conv)) : product.quantity,
                unitID: [product.unit_level[0].id],
                uom: [product.unit_level[0].id],
                isUseBigUom: product.isUseBigUom,
            })),
            cust_client: this.state.dataParam.cust_client,
            accept_half: partialOrderAcceptance ? 0 : 1,
            note: this.state.note,
            delivery: handlingDeliveryFee,
            delivery_action: deliveryAction || {
                key: true,
                tag: "1",
                text: "Kirim Ke Toko"
            },
            payment_type: selectedPaymentMethod,
            payment_primary: `{"key":${selectedPaymentMethod},"used":${totalPayment}}`,
            data_loyalty: [],
            metadata: {
                custNoSales: getCookies(COOKIES_CUSTOMER_ID),
                custNamaToko: this.state.titleHeader,
                custNoHp: this.state.custNoHp,
                products: productsToOrder.map((product) => ({
                    name: product.product_name,
                    product_id: product.internal_reference,
                    quantity: product.quantity.toString(),
                    unitID: product.uom_id,
                    uom: product.uom
                }))
            },
            cart_id: this.state.metadata_cart.cart_id,
        };

        this.setState({ isOrderButtonDisabled: true, isOrderingInProgress: true }, () => {
            onRequest(
                "/post/order",
                payload,
                (res_success) => {
                    const orderData = {
                        orderNumber: res_success.result.detail_so,
                        storeName: this.state.titleHeader,
                        wholesalerName: this.state.dataParam.wholesaler_name || 'N/A',
                        totalPayment: totalPayment,
                        orderTime: new Date()
                    };

                    this.setState({
                        orderSuccessModal: {
                            open: true,
                            orderData: orderData
                        },
                        loading_page: false,
                        isOrderingInProgress: false, // Hide overlay but keep button disabled
                    });
                },
                (res_fail) => {
                    console.log(JSON.stringify(res_fail))
                    this.setState({
                        loading_page: false,
                        isOrderButtonDisabled: false,
                        isOrderingInProgress: false,
                        error_dialog: {
                            message: res_fail?.message || "Oops! Something went wrong.",
                            result: { action: ERR_REFRESH, message: "Refresh" },
                        },
                    });
                }
            );
        });
    };

    addToCart(param) {
        try {
            const { cart, totalPrice, reff_id } = this.state;
            const totalPayment = this.getTotalPayment();
            // Mapping ulang agar format detail_order sesuai harapan
            const detail_order = cart.map(item => ({
                product_id: item.internal_reference,
                name: item.product_name,
                img: item.image_url,
                price: item.price_unit,
                uom_id: item.uom_id,
                uom_text: item.uom,
                quantity: item.quantity,
                convert: item.conv,
                unit_level: item.unit_level,
                price_level: item.price_level,
                calculation: item.calculation,
            }));

            const payload = {
                cust_no_toko_odoo: this.state.dataParam.cust_client,
                wholesaler_id: this.state.dataParam.wholesaler_id,
                cust_no_sales: getCookies(COOKIES_CUSTOMER_ID),
                total_price: totalPayment, // Use total payment instead of just totalPrice
                detail_order: JSON.stringify(detail_order),
                created_at: new Date(),
                created_by: getCookies(COOKIES_CUSTOMER_ID),
                reff_id: reff_id,
            };

            this.setState({ loading_page: true }, () => {
                onRequest(
                    "/post/add_to_cart",
                    payload,
                    (res_success) => {
                        if (param) {
                            this.props.history.goBack();
                        } else {
                            this.getCart();
                        }
                        this.setState({ loading_page: false, isOrderButtonDisabled: false });
                    },
                    (res_fail) => {
                        this.setState({ loading_page: false, isOrderButtonDisabled: false, error_page: res_fail });
                    }
                );
            });
        } catch (e) {
            this.setState({
                error_page: {
                    message: e.message,
                    result: { action: ERR_REFRESH, message: "Refresh" },
                },
            });
        }
    }

    backHome() {
        // this.props.history.replace("/retail_profile");
        // this.props.history.goBack();
        // set flag di sessionStorage supaya RetailProfile tahu ini berasal dari summary cart
        try {
            sessionStorage.setItem("retail_profile_override_back", "1");
        } catch (e) {
            // sessionStorage mungkin diblokir di beberapa env, tapi kita tetap lanjut
            // console.warn("sessionStorage not available", e);
        }

        // replace ke retail_profile (tetap SPA)
        this.props.history.replace({
            pathname: "/retail_profile",
            state: { backTo: "/dashboard", fromSummary: true },
        });
    }

    requestDocument(LOADING_TAG, ERROR_TAG, next_page) {
        try {
            this.setState({ [LOADING_TAG]: true }, () => {
                let body = {
                    cust_no_odoo: this.params.get("cust_odoo"),
                };
                let endpoint = "/show/customer";
                body.cust_no_sales = getCookies(COOKIES_CUSTOMER_ID);
                body.region_id = this.state.region_id_ul;
                //   if (next_page) {
                //     body.pagination = this.state.pagination;
                //   }
                onRequest(
                    endpoint,
                    body,
                    (res_success) => {
                        this.setState({
                            [LOADING_TAG]: false,
                            titleHeader: res_success.result[0].cust_nama_toko,
                            custNoHp: res_success.result[0].cust_no_hp,
                            // pagination: res_success.result.pagination,
                        });

                        this.getCart();
                        this.generateUniqueCode();
                    },
                    (res_fail) => {
                        this.setState({
                            [LOADING_TAG]: false,
                            [ERROR_TAG]: {
                                message: res_fail.message,
                                result: { action: ERR_REFRESH, message: "Refresh" },
                            },
                        });
                    }
                );
            });
        } catch (error) {
            console.log("error", error);
        }
    }

    calculateTempCartTotalPrice = (cart) => {
        let total = 0;
        const outOfStockSet = new Set(this.state.outOfStockProductIds || []);
        cart.forEach(item => {
            // Skip produk yang stock-nya habis (stock < 1)
            if (outOfStockSet.has(item.internal_reference)) {
                return;
            }
            total += this.getTiringPrice(item, item.quantity, item.uom_id);
        });
        return total;
    };

    getCart(callback) {
        try {
            this.setState({ loading_dialog: true }, () => {
                let payload = {
                    cust_no_sales: getCookies(COOKIES_CUSTOMER_ID),
                    cust_no_toko_odoo: this.state.dataParam.cust_client,
                    wholesaler_id: this.state.dataParam.wholesaler_id
                };
                let endpoint = "/show/get_cart";

                onRequest(
                    endpoint,
                    payload,
                    (res_success) => {
                        // Ambil detail_order dari response
                        const detail_order = res_success.result[0].detail_order;
                        // Mapping agar sesuai dengan struktur cart yang dipakai aplikasi
                        const cart = detail_order.map(item => {
                            // Cari UOM yang dipilih
                            const selectedUOMObj = item.unit_level?.find(uom => item.uom_id === uom.id) || item.unit_level?.[0];
                            const isUseBigUom = selectedUOMObj?.id === item.unit_level?.[1]?.id;
                            return {
                                internal_reference: item.product_id,
                                product_name: item.name,
                                image_url: item.img,
                                price_unit: Number(item.price),
                                quantity: item.quantity,
                                uom: selectedUOMObj?.text || item.uom_text,
                                uom_id: selectedUOMObj?.id || item.uom_id,
                                conv: item.convert,
                                isUseBigUom: !!isUseBigUom,
                                price_level: item.price_level,
                                unit_level: item.unit_level,
                                calculation: item.calculation,
                                pricing_strategy: item.pricing_strategy,
                            };
                        });

                        this.initialCart = JSON.parse(JSON.stringify(cart)); // Save initial cart state

                        this.setState({
                            loading_dialog: false,
                            cart,
                            metadata_cart: res_success.result[0],
                        }, () => {
                            this.checkStock(); // Fetch stock info after cart is loaded
                        });

                        const totalPrice = this.calculateTempCartTotalPrice(cart);

                        this.setState({ totalPrice });
                        this.createPayload(); // Create payload on initial load

                        if (callback) callback();
                    },
                    (res_fail) => {
                        this.setState({
                            loading_dialog: false,
                            error_dialog: {
                                message: res_fail.message,
                                result: { action: ERR_REFRESH, message: "Refresh" },
                            },
                        });
                    }
                );
            });
        } catch (error) {
            console.log("error", error);
        }
    }

    hasCartChanged() {
        const { cart } = this.state;
        if (cart.length !== this.initialCart.length) return true;

        for (let i = 0; i < cart.length; i++) {
            if (
                cart[i].internal_reference !== this.initialCart[i].internal_reference ||
                cart[i].quantity !== this.initialCart[i].quantity
            ) {
                return true;
            }
        }
        return false;
    }

    checkStock = () => {
        try {
            const { cart, dataParam } = this.state;
            if (!cart || cart.length === 0) {
                this.setState({ stockData: null, outOfStockProductIds: [] });
                return;
            }

            const products = cart.map((item) => {
                const unitLevels = (item.unit_level || []).map((uom) => ({
                    id: uom.id,
                    text: uom.text,
                    is_selected: uom.id === item.uom_id,
                }));
                const selectedUOM =
                    unitLevels.find((u) => u.is_selected) || unitLevels[0] || {};
                return {
                    product_id: item.internal_reference,
                    unit_id: selectedUOM.id || item.uom || null,
                    unit_label: selectedUOM.text || item.uom || null,
                    unit_levels: unitLevels,
                    id_bundle: null,
                    bundle_products: null,
                    is_bundle: false,
                    is_limited: true,
                    flashsale_id: null,
                    stock: null,
                };
            });

            const payload = {
                products,
                wholesaler_id: dataParam?.wholesaler_id,
                retail_id: dataParam?.cust_client,
                version: "1.5",
                view_id: "/stock/product",
            };

            onRequest(
                "/stock/product",
                payload,
                (res_success) => {
                    const stockResult = res_success?.result;

                    // Response checkStock: result.product[] (object dengan key "product")
                    const stockProducts =
                        stockResult && Array.isArray(stockResult.product)
                            ? stockResult.product
                            : [];

                    // Map stock response by product_id untuk lookup cepat
                    const stockByProductId = new Map();
                    stockProducts.forEach((p) => {
                        if (p && p.product_id != null) {
                            stockByProductId.set(p.product_id, Number(p.stock));
                        }
                    });

                    // Map ke cart items: untuk setiap product di cart, lookup stock by product_id
                    // Cart items menggunakan internal_reference (= product_id dari getCart)
                    const outOfStockIds = cart
                        .filter((item) => {
                            const stock = stockByProductId.get(item.internal_reference);
                            // null/undefined/NaN => data tidak tersedia, jangan tandai OOS
                            if (
                                stock === undefined ||
                                stock === null ||
                                Number.isNaN(stock)
                            ) {
                                return false;
                            }
                            return stock < 1;
                        })
                        .map((item) => item.internal_reference);

                    this.setState(
                        {
                            stockData: stockResult || null,
                            outOfStockProductIds: outOfStockIds,
                        },
                        () => {
                            // Recalculate total price supaya produk OOS tidak ikut dihitung
                            this.setState({
                                totalPrice: this.calculateTempCartTotalPrice(this.state.cart),
                            });
                        }
                    );
                },
                (res_fail) => {
                    console.log("Failed to fetch stock data:", res_fail);
                    this.setState({ stockData: null, outOfStockProductIds: [] });
                },
                `${process.env.REACT_APP_BASE_API_GP}/grosirpintar`
            );
        } catch (error) {
            console.log("error checkStock", error);
        }
    };

    generateUniqueCode() {
        let length = 10;
        const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters.charAt(randomIndex);
        }

        this.setState({
            reff_id: result,
        });
    }

    handlePaymentMethodChange = (event) => {
        this.setState({ selectedPaymentMethod: event.target.value });
    };

    handlePartialOrderChange = (event) => {
        this.setState({ partialOrderAcceptance: event.target.checked });
    };

    handleShippingMethodChange = (event) => {
        console.log(event.target.value);

        this.setState({ selectedShippingMethod: event.target.value });
    };

    handleCloseOrderModal = () => {
        this.setState({
            orderSuccessModal: {
                open: false,
                orderData: null
            }
        });
        this.backHome();
    };

    // Function to calculate handling and delivery fee
    getHandlingDeliveryFee = () => {
        return this.state.selectedShippingMethod ? Number(this.state.delivery_price) : 0;
    };

    // Function to calculate total payment including handling and delivery fee
    getTotalPayment = () => {
        return this.state.totalPrice + this.getHandlingDeliveryFee();
    };

    getSelectedUOM(product, uom_id) {
        if (uom_id) {
            product.unit_level = product.unit_level.map(uom => ({
                ...uom,
                is_selected: uom.id === uom_id
            }));
        }
        return product.unit_level.find(uom => uom.is_selected) || product.unit_level[0];
    }

    getRealPrice(priceLevel) {
        const price = this.toDecimal(priceLevel.price);
        const discount = this.toDecimal(priceLevel.discount || 0);
        const isPriceSameWithDiscount = price.equals(discount);
        const base = discount.greaterThan(0)
            ? isPriceSameWithDiscount ? price : discount
            : price;

        return base;
    }

    getTiringPrice(product, quantity, uom_id) {
        if (!product || !product.price_level || !product.unit_level) return 0;
        if (!quantity || quantity <= 0) return 0;

        const convert = Number(product.convert || product.conv || 1);
        const pricingStrategy = product.pricing_strategy || "FIX";
        const isBigUom =
            product.unit_level.length > 1 &&
            uom_id === product.unit_level[1]?.id;

        // Ambil harga efektif: pakai discount jika discount > 0 && discount < price
        const getEffectivePrice = (pl) => {
            const price = Number(pl.price);
            const discount = Number(pl.discount || 0);
            return discount > 0 && discount < price ? discount : price;
        };

        // Pisahkan price_level menjadi small (non-big) dan big, skip yang isDeleted
        const smallTiers = (product.price_level || [])
            .filter((pl) => pl.uom_type !== "big" && !pl.isDeleted)
            .map((pl) => ({
                quantity: Number(pl.quantity),
                price: getEffectivePrice(pl),
            }))
            .sort((a, b) => a.quantity - b.quantity);

        const bigTiers = (product.price_level || [])
            .filter((pl) => pl.uom_type === "big" && !pl.isDeleted)
            .map((pl) => ({
                quantity: Number(pl.quantity),
                price: getEffectivePrice(pl),
            }))
            .sort((a, b) => a.quantity - b.quantity);

        // Untuk satu segmen (all-small atau all-big):
        // cari tier tertinggi yang quantity-nya terpenuhi, lalu kalikan seluruh qty dengan harga tier tsb
        const calculateSegmentPrice = (qty, tiers) => {
            if (tiers.length === 0 || qty <= 0) return 0;
            let applicablePrice = tiers[0].price;
            for (let i = tiers.length - 1; i >= 0; i--) {
                if (qty >= tiers[i].quantity) {
                    applicablePrice = tiers[i].price;
                    break;
                }
            }
            return qty * applicablePrice;
        };

        // CONV: hanya small tiers. Big UOM dikonversi ke small dulu.
        if (pricingStrategy === "CONV") {
            const qtyInSmall = isBigUom ? quantity * convert : quantity;
            return calculateSegmentPrice(qtyInSmall, smallTiers);
        }

        // FIX + Big UOM: gunakan big tiers saja.
        if (isBigUom) {
            return calculateSegmentPrice(quantity, bigTiers);
        }

        // FIX + Small UOM:
        // - Dual UOM (bigTiers ada): pecah qty jadi bigCount (DUS) + smallRemainder (KLG)
        // - Single UOM / tidak ada big tier: pakai smallTiers untuk seluruh quantity
        if (bigTiers.length === 0) {
            if (smallTiers.length > 0) {
                return calculateSegmentPrice(quantity, smallTiers);
            }
            // Fallback: tidak ada tier sama sekali, pakai price_unit per-piece
            return quantity * Number(product.price_unit || product.price || 0);
        }

        const bigCount = Math.floor(quantity / convert);
        const smallRemainder = quantity % convert;
        // Fallback: kalau API tidak kirim small tier (hanya big tier yang dikembalikan),
        // gunakan price_unit per-piece untuk remainder supaya total = 2 box + 2 kaleng
        const smallPrice = smallTiers.length > 0
            ? calculateSegmentPrice(smallRemainder, smallTiers)
            : smallRemainder * Number(product.price_unit || product.price || 0);
        return calculateSegmentPrice(bigCount, bigTiers) + smallPrice;
    }

    getSelectedPriceLevel(product, quantity, uom_id) {
        if (!product || !product.price_level || !product.unit_level) return null;
        const selectedUOM = this.getSelectedUOM(product, uom_id);
        const convert = Number(product.convert || product.conv || 1);
        const priceLevels = product.price_level
            // .filter(pl => !pl.isDeleted)
            .map(pl => {
                let price = Number(pl.price);
                let discount = Number(pl.discount || 0);
                let bestPrice = price;
                if (
                    discount > 0 &&
                    discount < price
                ) {
                    bestPrice = discount;
                }
                return {
                    quantity: Number(pl.quantity),
                    price: bestPrice,
                    isChanged: pl.isChanged,
                    isDeleted: pl.isDeleted,
                };
            })
            .sort((a, b) => a.quantity - b.quantity);

        if (priceLevels.length === 0) return null;

        let qty = Number(quantity);
        if (selectedUOM.id === product.unit_level[1]?.id) {
            qty = qty * convert;
        }

        let activePriceLevel = null;

        if (product.calculation === 2) {
            for (let i = priceLevels.length - 1; i >= 0; i--) {
                if (qty >= priceLevels[i].quantity) {
                    activePriceLevel = priceLevels[i];
                    break;
                }
            }
        }

        if (product.calculation === 1 || product.calculation === undefined) {
            for (let i = priceLevels.length - 1; i >= 0; i--) {
                if (qty >= priceLevels[i].quantity) {
                    activePriceLevel = priceLevels[i];
                    break;
                }
            }
        }

        return activePriceLevel || priceLevels[0] || null;
    }

    // Lookup stock dari checkStock response (state.stockData) by product_id.
    // Stock dari API selalu per-satuan-kecil (unit_level[0]). Kalau cart item
    // pakai UOM besar (unit_level[1]), stock ditampilkan = floor(stock / conv).
    // Return null kalau stockData belum ada atau product_id tidak ditemukan.
    getCartItemStockNumber(item) {
        const stockResult = this.state.stockData;
        if (!stockResult || !Array.isArray(stockResult.product)) return null;

        const stockProduct = stockResult.product.find(
            (p) => p.product_id === item.internal_reference
        );
        if (!stockProduct || stockProduct.stock == null) return null;

        const stockNum = Number(stockProduct.stock);
        if (!Number.isFinite(stockNum)) return null;

        // Kalau UOM cart item adalah UOM besar, bagi dengan convert (floor).
        const unitLevels = item.unit_level || [];
        const isBigUom =
            unitLevels.length > 1 && item.uom_id === unitLevels[1]?.id;
        const conv = Number(item.conv || 1);

        if (isBigUom && conv > 1) {
            return Math.floor(stockNum / conv);
        }

        return stockNum;
    }

    // Max quantity untuk cart item = stock (sudah UOM-aware dari
    // getCartItemStockNumber) || MAX_QUANTITY (fallback kalau stock belum
    // dimuat). Return 0 kalau stock < 1 supaya caller skip.
    getMaxQuantityForCartItem(item) {
        if (!item) return MAX_QUANTITY;
        const stock = this.getCartItemStockNumber(item);
        if (stock === null || stock === undefined) return MAX_QUANTITY;

        const stockNum = Number(stock);
        if (!Number.isFinite(stockNum)) return MAX_QUANTITY;
        if (stockNum < 1) return 0;

        return Math.min(MAX_QUANTITY, stockNum);
    }

    renderCartItems() {
        const { cart, outOfStockProductIds } = this.state;
        const outOfStockSet = new Set(outOfStockProductIds || []);

        return cart.map((item) => {
            const activePriceLevel = this.getSelectedPriceLevel(item, item.quantity, item.uom_id);
            const showPriceChange = activePriceLevel?.isChanged === true;
            const showMinQtyChange = activePriceLevel?.isDeleted === true;
            const showIndicator = showPriceChange || showMinQtyChange;
            const isOutOfStock = outOfStockSet.has(item.internal_reference);

            return (
                <div
                    key={item.internal_reference}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 8,
                        padding: "8px 14px",
                        borderBottom: "1px solid #f0f0f0",
                        position: "relative",
                        backgroundColor: "white",
                    }}
                >
                    {/* Trash button - dipisah, tidak kena OOS styling */}
                    <IconButton
                        onClick={() => this.handleRemoveItem(item.internal_reference)}
                        title="Hapus produk dari keranjang"
                        aria-label="Hapus produk"
                        sx={{
                            color: "#f44336",
                            flexShrink: 0,
                            padding: 1,
                            "&:hover": {
                                color: "#c62828",
                                backgroundColor: "rgba(244, 67, 54, 0.08)",
                            },
                        }}
                    >
                        <DeleteOutlineIcon sx={{ fontSize: 24 }} />
                    </IconButton>

                    {/* Product details - div ini yang dapat OOS styling */}
                    <div
                        style={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            backgroundColor: isOutOfStock ? "#f5f5f5" : "transparent",
                            opacity: isOutOfStock ? 0.55 : 1,
                            filter: isOutOfStock ? "grayscale(60%)" : "none",
                            borderRadius: 6,
                            padding: isOutOfStock ? "8px 10px" : 0,
                        }}
                    >
                        {/* Image + (nama + harga) */}
                        <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                            <img
                                src={
                                    item.image_url || "https://fakeimg.pl/600x400?text=Img&font=museo"
                                }
                                alt={item.product_name}
                                style={{
                                    width: 56,
                                    height: 56,
                                    objectFit: "contain",
                                    borderRadius: 6,
                                    border: "1px solid #f0f0f0",
                                    backgroundColor: "#fafafa",
                                    flexShrink: 0,
                                }}
                            />

                            <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                                {/* nama produk */}
                                <div
                                    style={{
                                        fontWeight: 600,
                                        fontSize: 14,
                                        color: "#222",
                                        lineHeight: 1.35,
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {item.product_name}
                                </div>

                                {/* harga */}
                                <div
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: "#ee2625",
                                        marginTop: 4,
                                    }}
                                >
                                    {this.formatCurrencys(this.getTiringPrice(item, item.quantity, item.uom_id))}
                                </div>
                            </div>
                        </div>

                        {/* uom tag + quantity controls */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span
                                    style={{
                                        fontSize: 11,
                                        color: "#666",
                                        backgroundColor: "#f5f5f5",
                                        padding: "3px 8px",
                                        borderRadius: 4,
                                        fontWeight: 500,
                                    }}
                                >
                                    {item.uom}
                                </span>
                                {(() => {
                                    const stockNumber = this.getCartItemStockNumber(item);
                                    const hasStock = stockNumber !== null;
                                    const isZero = hasStock && stockNumber === 0;
                                    return (
                                        <span
                                            style={{
                                                fontSize: 11,
                                                color: isZero ? "#c62828" : "#888",
                                                fontWeight: 500,
                                            }}
                                        >
                                            Stok: {hasStock ? stockNumber.toLocaleString() : "-"}
                                        </span>
                                    );
                                })()}
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <button
                                    onClick={() => this.handleRemove(item.internal_reference)}
                                    disabled={isOutOfStock}
                                    style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 6,
                                        border: "1px solid #f44336",
                                        backgroundColor: isOutOfStock ? "#e0e0e0" : "white",
                                        color: isOutOfStock ? "#9e9e9e" : "#f44336",
                                        fontWeight: "bold",
                                        cursor: isOutOfStock ? "not-allowed" : "pointer",
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    −
                                </button>
                                <span
                                    style={{
                                        margin: "0 12px",
                                        fontWeight: 700,
                                        fontSize: 14,
                                        color: "#333",
                                        minWidth: 20,
                                        textAlign: "center",
                                    }}
                                >
                                    {item.quantity}
                                </span>
                                <button
                                    onClick={() => this.handleAdd(item.internal_reference)}
                                    disabled={isOutOfStock}
                                    style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 6,
                                        border: "1px solid #9cd600",
                                        backgroundColor: isOutOfStock ? "#e0e0e0" : "#9cd600",
                                        color: isOutOfStock ? "#9e9e9e" : "white",
                                        fontWeight: "bold",
                                        cursor: isOutOfStock ? "not-allowed" : "pointer",
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        {showIndicator && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 4,
                                    backgroundColor: showMinQtyChange ? "#fff3cd" : "#e3f2fd",
                                    color: showMinQtyChange ? "#856404" : "#0d47a1",
                                    padding: "6px 10px",
                                    borderRadius: 6,
                                    fontSize: 11,
                                    fontWeight: 600,
                                }}
                            >
                                <InfoOutlinedIcon style={{ fontSize: 14 }} />
                                <span>
                                    {showMinQtyChange ? (
                                        `Tiring harga dengan min. qty (${activePriceLevel?.quantity}) tidak ada lagi`
                                    ) : (
                                        `Terjadi perubahan harga pada tiring harga dengan min. qty (${activePriceLevel?.quantity})`
                                    )}
                                </span>
                            </div>
                        )}
                        {isOutOfStock && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 4,
                                    backgroundColor: "#ffebee",
                                    color: "#c62828",
                                    padding: "6px 10px",
                                    borderRadius: 6,
                                    fontSize: 11,
                                    fontWeight: 600,
                                }}
                            >
                                <InfoOutlinedIcon style={{ fontSize: 14 }} />
                                <span>Produk tidak tersedia karena stok habis</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    }

    renderOrderSuccessModal() {
        const { orderSuccessModal } = this.state;
        const { orderData } = orderSuccessModal;

        if (!orderData) return null;

        const formatDate = (date) => {
            return new Intl.DateTimeFormat('id-ID', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        };

        const formatCurrency = (amount) => {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(amount);
        };

        return (
            <Dialog
                open={orderSuccessModal.open}
                onClose={this.handleCloseOrderModal}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        padding: 2
                    }
                }}
            >
                <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
                    <IconButton
                        onClick={this.handleCloseOrderModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
                    <Box sx={{ mb: 3 }}>
                        <CheckCircleIcon
                            sx={{
                                fontSize: 80,
                                color: '#4CAF50',
                                mb: 2
                            }}
                        />
                        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2E7D32', mb: 1 }}>
                            Pesanan Berhasil Dibuat!
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Pesanan Anda telah berhasil diproses
                        </Typography>
                    </Box>

                    <Paper
                        elevation={0}
                        sx={{
                            backgroundColor: '#f8f9fa',
                            p: 3,
                            borderRadius: 2,
                            border: '1px solid #e9ecef'
                        }}
                    >
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#495057', mb: 2 }}>
                                Detail Pesanan
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                            <Typography variant="body2" color="textSecondary" align="left">
                                No. Pesanan:
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#495057', textAlign: 'right' }}>
                                {orderData.orderNumber}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                            <Typography variant="body2" color="textSecondary" align="left">
                                Nama Toko:
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#495057', textAlign: 'right' }}>
                                {orderData.storeName}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                            <Typography variant="body2" color="textSecondary" align="left">
                                Grosir:
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#495057', textAlign: 'right' }}>
                                {orderData.wholesalerName}
                            </Typography>
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                            <Typography variant="body2" color="textSecondary" align="left">
                                Total Pembayaran:
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#2E7D32', textAlign: 'right' }}>
                                {formatCurrency(orderData.totalPayment)}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body2" color="textSecondary" align="left">
                                Waktu Pesanan:
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#495057', textAlign: 'right' }}>
                                {formatDate(orderData.orderTime)}
                            </Typography>
                        </Box>
                    </Paper>

                    <Box sx={{ mt: 3 }}>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                            Terima kasih atas pesanan Anda! Kami akan segera memproses pesanan ini.
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'center', pt: 0, pb: 2 }}>
                    <Button
                        onClick={this.handleCloseOrderModal}
                        variant="contained"
                        sx={{
                            backgroundColor: '#ee2625',
                            color: 'white',
                            fontWeight: 'bold',
                            px: 4,
                            py: 1.5,
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: '#8bc34a',
                            },
                        }}
                    >
                        Tutup
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    formatCurrencys = (amount) => {
        if (amount == null || isNaN(amount)) return "Rp 0";

        const hasDecimal = amount % 1 !== 0; // cek apakah ada desimal

        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: hasDecimal ? 2 : 0,
            maximumFractionDigits: hasDecimal ? 2 : 0,
        }).format(amount);
    };

    render() {
        const {
            cart,
            showFloatingButton,
            selectedPaymentMethod,
            totalPrice,
            paymentOptions,
            isOrderButtonDisabled,
            isOrderingInProgress,
        } = this.state;
        const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
        const buttonText = this.hasCartChanged()
            ? "Update Qty Produk"
            : "Pesan Sekarang";
        const isOrderNow = !this.hasCartChanged();
        const orderButtonDisabled =
            isOrderNow && (isOrderButtonDisabled || isOrderingInProgress);

        return (
            <div className="app" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                {/* Full page loading overlay - only shows during API call, hides when API returns */}
                {isOrderingInProgress && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "white",
                                padding: "30px 50px",
                                borderRadius: "15px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                            }}
                        >
                            <CircularProgress size={50} sx={{ color: "#9cd600", mb: 2 }} />
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
                                Processing Order...
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
                                Please wait, do not close this page. This may take a moment.
                            </Typography>
                        </div>
                    </div>
                )}

                <div
                    className="ntv_header_a ntv_bg_color_a"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <div
                        onClick={() => this.props.history.goBack()}
                        className="crs_pointer view_center"
                        style={{ width: 60, height: "100%" }}
                    >
                        <img alt="" src={ic_left} style={{ width: 24 }} />
                    </div>
                    <div style={{ padding: "0 20px", flex: 1 }}>
                        <span className="crs_default fnt_wht_a txt_16">
                            {this.state.titleHeader}
                        </span>
                    </div>
                </div>

                <div
                    className="app_phone_root"
                    style={{
                        flex: 1,
                        position: "relative",
                        overflowY: "auto",
                        marginBottom: 150,
                        paddingRight: 15,
                        paddingLeft: 15,
                    }} // Add paddingBottom
                >
                    <div className="app_phone_ctn">
                        {/* Dropdown shipping method */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                // padding: "10px",
                                // border: "1px solid #ddd", // Add border
                                // borderRadius: "10px", // Add border radius
                                backgroundColor: "white",
                                marginBottom: 20,
                                marginTop: 20,
                            }}
                        >
                            <label
                                htmlFor="shipping-method"
                                style={{
                                    display: "block",
                                    marginBottom: "10px",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }}
                            >
                                Metode Pengambilan Barang:
                            </label>

                            {/* <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <span>image</span>
                                <span>
                                   button untuk change type
                                </span>
                            </div> */}
                            <FormControl fullWidth size="small">
                                <Select
                                    id="shipping-method"
                                    value={this.state.selectedShippingMethod}
                                    onChange={this.handleShippingMethodChange}
                                    style={{
                                        borderRadius: "5px",
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    {this.state.shippingOptions.map((option, index) => (
                                        <MenuItem key={index} value={option.key}>
                                            {option.text}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginBottom: 10,
                            }}
                        ></div>

                        {this.renderCartItems()}

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginTop: 20,
                                marginBottom: 20,
                            }}
                        ></div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <div
                                style={{
                                    flexDirection: "column",
                                    display: "flex",
                                }}
                            >
                                <span style={{ fontWeight: "bold" }}>Perlu Produk Lain?</span>
                                {/* <span style={{ color: "#888", marginTop: 5 }}>
                                    Add others, if you want
                                </span> */}
                            </div>
                            <button
                                onClick={() => this.addToCart(true)}
                                style={{
                                    padding: 10,
                                    borderRadius: "5px",
                                    border: "1px solid #9cd600",
                                    backgroundColor: "white",
                                    color: "#9cd600",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Tambah Produk
                            </button>
                        </div>

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginTop: 20,
                                marginBottom: 20,
                            }}
                        ></div>

                        <div style={{ marginBottom: "10px" }}>
                            <TextField
                                label="Tambah Catatan"
                                placeholder="Tulis catatan untuk pesanan Anda disini..."
                                value={this.state.note}
                                onChange={(e) => this.setState({ note: e.target.value })}
                                multiline
                                rows={3}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    style: {
                                        borderRadius: "8px",
                                    },
                                }}
                            />
                        </div>

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginTop: 20,
                                marginBottom: 20,
                            }}
                        ></div>

                        {/* Dropdown payment method */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                backgroundColor: "white",
                                marginBottom: 10,
                            }}
                        >
                            <label
                                htmlFor="payment-method"
                                style={{
                                    display: "block",
                                    marginBottom: "10px",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }}
                            >
                                Pilih Metode Pembayaran:
                            </label>
                            <FormControl fullWidth size="small">
                                <Select
                                    disabled
                                    id="payment-method"
                                    value={selectedPaymentMethod}
                                    onChange={(event) => this.handlePaymentMethodChange(event)}
                                    style={{
                                        borderRadius: "5px",
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    {paymentOptions.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginTop: 20,
                                marginBottom: 10,
                            }}
                        ></div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <p style={{ fontWeight: "bold" }}>Rincian Pembayaran</p>
                            {/* <p onClick={() => alert("jiahahahah")} style={{ fontWeight: "bold", fontSize: 12, color: "#9cd600", cursor: "pointer" }}>Add discount</p> */}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                padding: 15,
                                border: "1px solid #ddd", // Add border
                                borderRadius: "10px", // Add border radius
                                backgroundColor: "white",
                                marginBottom: 20,
                                // marginTop: 10,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <span>Harga</span>
                                <span>
                                    {this.formatCurrencys(totalPrice || 0)}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <span>Biaya Layanan Aplikasi</span>
                                <span>
                                    {this.formatCurrencys(this.getHandlingDeliveryFee())}
                                </span>
                            </div>
                            {/* Hapus baris discount */}
                            {/* <div>Discount</div> */}
                            {/* <div>Total Discount</div> */}

                            <div
                                style={{
                                    height: 0.1,
                                    border: "1px solid #ddd",
                                    backgroundColor: "#ddd",
                                    marginTop: 20,
                                    marginBottom: 20,
                                }}
                            ></div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <span style={{ fontWeight: "bold" }}>Total Pembayaran</span>
                                <span style={{ fontWeight: "bold" }}>
                                    {this.formatCurrencys(this.getTotalPayment())}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Floating Button */}
                <div
                    className="app_phone_root crs_pointer"
                    style={{ position: "relative" }}
                >
                    <div
                        className="app_phone_ctn"
                        style={{
                            display: "flex",
                            flexDirection: "column", // Changed to column to stack elements
                            position: "fixed",
                            bottom: 0,
                            width: "100%",
                            backgroundColor: "white",
                            padding: 20,
                            boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <label
                            style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#333",
                            }}
                        >
                            <input
                                className="ntv_accent_a"
                                type="checkbox"
                                checked={this.state.partialOrderAcceptance}
                                onChange={this.handlePartialOrderChange}
                                style={{
                                    marginRight: "10px",
                                    transform: "scale(1.2)",
                                    cursor: "pointer",
                                }}
                            />
                            Saya memastikan data pesanan sudah sesuai. Jika nanti ada selisih stok atau penambahan produk di luar daftar, Grosir bisa menyesuaikan.
                        </label>

                        <div
                            style={{
                                height: 0.3,
                                border: "1px solid #ddd",
                                backgroundColor: "#ddd",
                                marginTop: 10,
                                marginBottom: 5,
                            }}
                        ></div>

                        <button
                            disabled={orderButtonDisabled}
                            style={{
                                width: "75%",
                                backgroundColor: orderButtonDisabled
                                    ? "#aaaaaa"
                                    : this.hasCartChanged() ? "#d6c211" : "#9cd600",
                                padding: 10,
                                borderRadius: 20,
                                color: "white",
                                textAlign: "center",
                                fontWeight: "bold",
                                border: "none",
                                cursor: orderButtonDisabled ? "not-allowed" : "pointer",
                                fontSize: 16,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 10,
                            }}
                            onClick={() => {
                                if (!this.hasCartChanged()) {
                                    const outOfStockSet = new Set(this.state.outOfStockProductIds || []);
                                    const availableProducts = this.state.cart.filter(
                                        (p) => !outOfStockSet.has(p.internal_reference)
                                    );
                                    if (availableProducts.length === 0) {
                                        this.setState({
                                            alert_dialog: {
                                                title: "Pemberitahuan",
                                                message: "Tidak ada stok produk yang tersedia",
                                                btn_message: "OK",
                                                listener: null,
                                            },
                                        });
                                        return;
                                    }
                                }

                                this.setState({
                                    isOrderButtonDisabled: true,
                                }, () => {
                                    if (this.hasCartChanged()) {
                                        this.addToCart(false);
                                    } else {
                                        // Refresh cart first to get updated prices before creating order
                                        // this.getCart(() => {
                                        this.createOrder();
                                        // });
                                    }
                                });
                            }}
                        >
                            {orderButtonDisabled ? (
                                <>
                                    <CircularProgress size={20} color="inherit" />
                                    Processing...
                                </>
                            ) : (
                                buttonText
                            )}
                        </button>
                    </div>
                </div>

                {showFilterDialog(this, () => {
                    this.requestDocument("loading_dialog", "error_dialog", false);
                })}
                {showConfirmation(this)}
                {showAlertDialog(this)}
                {showErrorPage(this)}
                {showErrorDialog(this)}
                {showLoadingPage(this)}
                {showLoadingDialog(this)}
                {this.renderOrderSuccessModal()}
            </div>
        );
    }
}

export default withRouter(SummaryCartReguler);
